
import { Vue, Component, Emit, Prop, Watch, Ref } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import lazyInject from '@/di';
import CarService from '@/services/car.service';

@Component({})
export default class CarShopEditor extends Vue {
  isVisible = false;

  title = '';

  formData: any = {
    market_id: undefined,
    market_name: '',
    sub_name: '',
  };

  @lazyInject(CarService)
  carService!: CarService;

  @Prop()
  encryptTels!: string;

  submittable = false;

  adUserPhone = '';

  adUserBind = false;

  field: any = {};

  rules: any = {};

  marketList: any = [];

  @Prop({
    default: () => {
      return '';
    },
  })
  shopId!: string;

  @Prop()
  editingField!: any;

  @Prop()
  poi!: string;

  @Ref()
  readonly ruleForm!: FormModel;

  @Watch('editingField', { deep: true })
  watchEditingField() {
    if (this.editingField == null) {
      return;
    }
    this.title = this.editingField.fieldTitle;
    this.field = { ...this.editingField };
  }

  @Emit('submit')
  onConfirm() {
    // console.log(this.formData);
    const { market_id, sub_name } = this.formData;
    const params = {
      market_id: market_id || 0,
      sub_name,
    };
    return params;
  }

  handleForceRefresh() {
    this.$emit('refresh');
  }

  close() {
    this.isVisible = false;
    this.field = null;
  }

  open() {
    const { sub_name, market_id } = this.editingField.value;
    this.formData = {};
    this.formData = {
      market_id: market_id || undefined,
      sub_name,
    };
    this.getMarket();
    // if (this.field?.label === ECarShopField.ADVERTISER_MOBILE_PHONE_NUMBER) {
    //   this.shopBk();
    // }
  }

  handleSubmittable(submittable: boolean) {
    this.submittable = submittable;
  }

  mounted() {
    this.watchEditingField();
  }

  async getMarket() {
    const res = await this.carService.getCarMarket({ shop_id: this.shopId });
    // console.log(res);
    this.isVisible = true;

    this.marketList = res;
  }
}
